import axios from "axios";
import { BASEURL } from "../../API/apiData";
import { fetchRequestOptions } from "../requestOptions/requestOptions";

export const fetchEngagementStats = async () => {
  try {
    const result = await axios.get(
      `${BASEURL}engagement`,
      fetchRequestOptions
    );
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchUserEngagements = async () => {
  try {
    const result = await axios.get(
      `${BASEURL}engagement_user_stats`,
      fetchRequestOptions
    );
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchProjectEngagements = async () => {
  try {
    const result = await axios.get(
      `${BASEURL}engagement_project_stats`,
      fetchRequestOptions
    );
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchSuggestionEngagements = async () => {
  try {
    const result = await axios.get(
      `${BASEURL}engagement_suggestion_stats`,
      fetchRequestOptions
    );
    return result.data;
  } catch (error) {
    console.log(error);
  }
};